// src/hooks/useScrollEffect.js
import { useEffect, useRef } from 'react';

const useScrollEffect = () => {
  const contentRef = useRef(null);
  
  useEffect(() => {
    const contentWrapper = contentRef.current;
    if (!contentWrapper) return;
    
    let scrollTimeout;
    
    const handleScroll = () => {
      // Add animation class when scrolling
      contentWrapper.classList.add('content-scrolling');
      
      // Clear previous timeout
      clearTimeout(scrollTimeout);
      
      // Remove animation class after scrolling stops
      scrollTimeout = setTimeout(() => {
        contentWrapper.classList.remove('content-scrolling');
      }, 1000);
    };
    
    // Add scroll event listener
    const appContent = document.querySelector('.app-content');
    if (appContent) {
      appContent.addEventListener('scroll', handleScroll);
    }
    
    // Clean up
    return () => {
      if (appContent) {
        appContent.removeEventListener('scroll', handleScroll);
      }
      clearTimeout(scrollTimeout);
    };
  }, []);
  
  return contentRef;
};

export default useScrollEffect;


